module.exports = __webpack_public_path__ + "img/img_idcard@2x.a5b94688.png";